export enum ThemeVariant {
    White,
    Black,
}
